<template>
    <!--theme one-->
    <div>
       <WithdrawPopup v-model:show="show" :data-set="dataSet"  @change-value="valueChange"
       @close="close" @confirm-withdraw="confirmWithdraw" @select-tab-type="selectTabType" @open="open" /> 
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { ref, defineExpose, defineEmits, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { playClickSound } from '@/utils/media';
import { withdraw } from '@/api/withdraw';
import { useUserStore } from '@/stores/user';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useWithdrawStore } from '@/stores/withdraw';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import WithdrawPopup from '@/themes/themeOne/withdraw/withdrawPopup.vue';
import { Channel, TAB_TYPE_LIST, WithdrawPopupData } from './supportScript';

const { t } = useI18n();
const userStore = useUserStore()
const withdrawStore = useWithdrawStore()
const uID = computed(() => userStore.id)
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()

const selectedChannel = computed(() => withdrawStore.selectedChannel as Channel)
const activeTab = ref(TAB_TYPE_LIST[0])
const cpfID = ref('')
const emailID = ref('')
const phoneID = ref('')
const evpID = ref('')
const userName = ref('')
const cpfNumber = ref('')
const brazilID = ref('')
const bank = ref('')
const showCPFIdError = ref(true)
const showEmaiIdError = ref(true)
const showPhoneIdError = ref(true)
const showEvpIdError = ref(true)
const showCPFNumError = ref(false)
const activeButton = ref(false)
const selectedAmount = ref(0)
const isDisabled = ref(false)

const dataSet = computed<WithdrawPopupData>(() => ({
    show: show.value,
    selectedChannel: selectedChannel.value,
    activeTab: activeTab.value,
    cpfID: cpfID.value,
    emailID: emailID.value,
    phoneID: phoneID.value,
    evpID: evpID.value,
    userName: userName.value,
    cpfNumber: cpfNumber.value,
    brazilID: brazilID.value,
    bank: bank.value,
    showCPFIdError: showCPFIdError.value,
    showEmaiIdError: showEmaiIdError.value,
    showPhoneIdError: showPhoneIdError.value,
    showEvpIdError: showEvpIdError.value,
    showCPFNumError: showCPFNumError.value,
    activeButton: activeButton.value,
    selectedAmount: selectedAmount.value,
    isDisabled: isDisabled.value,
}))

const emits = defineEmits(['handleClose'])

const open = (amount: number, data: any) => {
    playClickSound()
    show.value = true
    selectedAmount.value = amount
    if (data) {
        cpfID.value = data.cpf || ''
        emailID.value = data.email || ''
        phoneID.value = data.phone || ''
        evpID.value = data.email || ''
        userName.value = data.userName || ''
        cpfNumber.value = data.cpfId || ''
        brazilID.value = data.brazilId || ''
        if (data?.isEditable == 1) {
            isDisabled.value = true
        } else {
            isDisabled.value = false
        }
    }
}
const close = () => {
    show.value = false
    emits('handleClose')
    cpfID.value = ''
    emailID.value = ''
    phoneID.value = ''
    evpID.value = ''
    userName.value = ''
    cpfNumber.value = ''
    brazilID.value = ''
    bank.value = ''
}

const selectTabType = (item: any) => {
    activeTab.value = item
    // checkFieldsFill()
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const confirmWithdraw = () => {
    console.log('confirmWithdraw',emailID.value);
    loadingRef.value.open()
    let data: any = {
        payment_channel_id: selectedChannel.value.id,
        amount: selectedAmount.value,
        tax_type: activeTab.value.name,
        tax_id: activeTab.value.name == 'CPF' ? cpfID.value :
            activeTab.value.name == 'E-mail' ? emailID.value :
                activeTab.value.name == 'PHONE' ? phoneID.value :
                    activeTab.value.name == 'EVP' ? evpID.value : '',
        account_name: userName.value,
        cpf_id: cpfNumber.value,
        uid: uID.value,
    }

    if (selectedChannel.value.name === 'winwinpay') {
        data.bank_name = bank.value
    } else if (selectedChannel.value.name === 'uupay') {
        data.bank_name = bank.value
        data.identity_no = brazilID.value
    }
    withdraw(data).then(res => {
        loadingRef.value.close()
        showSuccess(res.msg)
        setTimeout(() => {
            userStore.getInfo()
            close()
        }, 500)
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
        setTimeout(() => {
            userStore.getInfo()
            close()
        }, 500)

    })
}
// const checkFieldsFill = () => {
   
//     if (activeTab.value.id == 1) {
//         activeButton.value = (cpfID.value != '') &&
//             (userName.value != '') &&
//             (cpfNumber.value != '') &&
//             !showCPFIdError.value &&
//             !showCPFNumError.value
//             ? true : false
//     } else if (activeTab.value.id == 2) {
//         activeButton.value = (emailID.value != '') &&
//             (userName.value != '') &&
//             (cpfNumber.value != '') &&
//             !showEmaiIdError.value &&
//             !showCPFNumError.value
//             ? true : false
//     } else if (activeTab.value.id == 3) {
//         activeButton.value = (phoneID.value != '') &&
//             (userName.value != '') &&
//             (cpfNumber.value != '') &&
//             !showPhoneIdError.value &&
//             !showCPFNumError.value
//             ? true : false
//     } else if (activeTab.value.id == 4) {
//         activeButton.value = (evpID.value != '') &&
//             (userName.value != '') &&
//             (cpfNumber.value != '') &&
//             !showEvpIdError.value &&
//             !showCPFNumError.value
//             ? true : false
//     }
//     console.log("checkFieldsFill called", activeButton.value);
// }
const valueChange = (data : any) =>{
    if(data.type === 'cpfID'){
        cpfID.value = data.value
    }else if(data.type === 'emailID'){
        emailID.value = data.value
    }else if(data.type === 'phoneID'){
        phoneID.value = data.value
    }else if(data.type === 'evpID'){
        evpID.value = data.value
    }else if(data.type === 'cpfNumber'){
        cpfNumber.value = data.value
    }else if(data.type === 'userName'){
        userName.value = data.value
    }else if(data.type === 'brazilID'){
        brazilID.value = data.value
    }else if(data.type === 'bank'){
        bank.value = data.value
    }
}
defineExpose({
    open,
    close
})

</script>
<style scoped>
.popupContainer {
    background: url('@/assets/main_bg.png');
    background-size: cover;
    background-repeat: repeat;
    width: 100%;
    min-height: 90vh;
    padding: 50px 0;
    overflow-y: auto;
}

.InfoList {
    padding: 10px 25px;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.topAmount {
    border-bottom: solid 0.5px rgba(255, 255, 255, 0.25);
    margin-bottom: 15px;
}

.inputLabel {
    color: #ffffffd9;
    font-size: 14px;
}

.amountRow {
    padding: 15px 0;

}

.amount {
    font-size: 15px;
    color: #FFF;
    padding-left: 15px;
}

.left_icon {
    color: rgba(255, 255, 255, 0.65);
    font-size: 17px;
    font-weight: bold;
    padding-right: 10px;
}

.tabList {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    padding: 10px 5px;
}

.tabList::-webkit-scrollbar {
    display: none;
}

.tab_card {
    border-radius: 30px;
    width: 70px;
    color: #ffffff;
    background-color: #ffffff26;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin-right: 10px;
    font-size: 14px;
}

.active_tab {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
    border-radius: 30px;
}

.input_field>>>.van-field {
    border-radius: 10px;
    background-color: #ffffff26;
    color: #ffffffd9;
    padding: 12px 20px !important;
    margin-top: 10px;
}

.input_field>>>.van-field__control {
    color: #ffffffa6 !important;
    font-size: 12px;

}

.input_field {
    padding: 10px 0;
}

.btn_container {
    padding: 10px 80px;
}

.errorText {
    color: red;
}
</style>